<template>
  <h3 class="title">收益计算</h3>
  <div class="input-frame">
    <label for="stock-identifier">标的物:</label>
    <div class="auto-complete-container">
      <input
        type="text"
        v-model="searchQuery"
        @input="handleInput"
        @focus="showSuggestions = true"
        @blur="handleBlur"
        placeholder="请输入标的物代码或名称"
        class="input-field"
      />
      <ul v-if="showSuggestions && suggestions.length" class="suggestions-list">
        <li
          v-for="(suggestion, index) in suggestions"
          :key="index"
          @click="selectSuggestion(suggestion)"
          class="suggestion-item"
        >
          {{ suggestion }}
        </li>
      </ul>
    </div>

    <label for="buy-price">买入价格:</label>
    <input type="number" v-model="buyPrice" class="input-field" @input="updateKnockOutPrice" />

    <label for="sell-price">卖出价格:</label>
    <input type="number" v-model="sellPrice" class="input-field" />

    <label for="option-rate">期权费率:</label>
    <input type="number" v-model="optionRate" class="input-field" />

    <label for="knock-out-price">敲出价格:</label>
    <input type="number" v-model="knockOutPrice" class="input-field" readonly />

    <button @click="calculate" class="button">收益计算</button>
  </div>

  <div class="results-container">
    <div class="result-frame">
      <h4 class="subtitle">成本&涨幅</h4>
      <!-- 结果显示区域 -->
      <p v-for="(result, key) in results" :key="key" class="result-item">{{ key }}: {{ result }}</p>
    </div>

    <div class="normal-result-frame">
      <h4 class="subtitle">正常收益</h4>
      <!-- 正常收益结果显示区域 -->
      <p v-for="(result, key) in normalResults" :key="key" class="result-item">{{ key }}: {{ result }}</p>
    </div>

    <div class="knock-out-result-frame">
      <h4 class="subtitle">敲出收益</h4>
      <!-- 敲出收益结果显示区域 -->
      <p v-for="(result, key) in knockOutResults" :key="key" class="result-item">{{ key }}: {{ result }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CalculationTab',
  data() {
    return {
      searchQuery: '',
      suggestions: [],
      showSuggestions: false,
      timeout: null,
      buyPrice: 0,
      sellPrice: 0,
      optionRate: 0,
      knockOutPrice: 0,
      results: {},
      normalResults: {},
      knockOutResults: {},
      isGrowthStock: false, // 标记是否属于创业板
    };
  },
  props: {
    stockHandler: {
      type: Object,
      required: true,
    },
    calculationCallback: {
      type: Function,
      required: true,
    },
  },
  watch: {
    stockHandler: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.buyPrice = newVal.buyPrice;
        this.searchQuery = newVal.code;
        this.sellPrice = newVal.sellPrice;
        this.optionRate = newVal.optionRate;
        this.updateKnockOutPrice();
      },
    },
  },
  methods: {
    async fetchSuggestions(query) {
      try {
        const response = await axios.get('/api/stock_list', { params: { query } });
        this.suggestions = response.data;
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    async save_funds() {
      try {
        const payload = {
          stockIdentifier: this.searchQuery,
          buyPrice: parseFloat(this.buyPrice).toFixed(4),
          sellPrice: parseFloat(this.sellPrice).toFixed(4),
          optionRate: parseFloat(this.optionRate).toFixed(4),
          knockOutPrice: parseFloat(this.knockOutPrice).toFixed(4),
          results: this.results,
          normalResults: this.normalResults,
          knockOutResults: this.knockOutResults,
          isGrowthStock: this.isGrowthStock,
        };

        const response = await axios.post('/api/save_funds', payload);
        console.log('保存成功:', response.data);
      } catch (error) {
        console.error('保存资金失败:', error);
      }
    },
    handleInput() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.searchQuery.length >= 1) {
          this.fetchSuggestions(this.searchQuery);
        } else {
          this.suggestions = [];
        }
      }, 300);
    },
    handleBlur() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
    },
    selectSuggestion(suggestion) {
      this.searchQuery = suggestion;
      this.suggestions = [];
      this.isGrowthStock = suggestion.includes('300');
      this.updateKnockOutPrice();
      this.$emit('select', suggestion);
    },
    updateKnockOutPrice() {
      if (this.buyPrice > 0) {
        const multiplier = this.isGrowthStock ? 1.2 : 1.1;
        this.knockOutPrice = (this.buyPrice * Math.pow(multiplier, 3)).toFixed(3);
      } else {
        this.knockOutPrice = 0;
      }
    },
    calculate() {
      const formattedBuyPrice = parseFloat(this.buyPrice).toFixed(4);
      const formattedSellPrice = parseFloat(this.sellPrice).toFixed(4);
      const formattedOptionRate = parseFloat(this.optionRate).toFixed(4);
      const formattedKnockOutPrice = parseFloat(this.knockOutPrice).toFixed(4);

      const res = this.calculationCallback(
        formattedBuyPrice,
        formattedSellPrice,
        formattedOptionRate,
        formattedKnockOutPrice
      );

      this.results = res[0];
      this.normalResults = res[1];
      this.knockOutResults = res[2];
      this.save_funds();
    },
  },
};
</script>

<style scoped>
@import '../assets/css/CalculationTab.css';
</style>
